export default __webpack_public_path__ + "static/media/datenschutz_bg.bcc2f542.jpg";